module.exports = __webpack_public_path__ + "img/free-standing-wall-1.957946e4.jpeg";